import React from 'react'
import womanEatSpag from "../asset/woman-eating.png"

const Eatingwo = () => {
  return (
    <div>
      <div className="eatingWo">
          <img src={womanEatSpag}className='w-100' alt="" />
        </div>
    </div>
  )
}

export default Eatingwo;